import { ASSOCIATION_TYPE } from '@/api/resources/configuration/peopleManagement/AssociationTypes'

export default {
    methods: {
        setAssociationLaboratories(associationParsed, associations, associationType, laboratories) {
            let allLabs = null
            associationParsed.laboratories.forEach(lab => {
                associations.forEach(association => {
                    if (association[associationType].id === associationParsed[associationType].id) {
                        if (association.laboratory && lab.labId === association.laboratory.labId) {
                            if (associationType === ASSOCIATION_TYPE.ROLE.key) {
                                lab.userappRoleId = association.id
                            } else if (associationType === ASSOCIATION_TYPE.OPERATION.key) {
                                lab.userappOperationId = association.id
                                if (association.role) {
                                    lab.roles.push(association.role)
                                }
                            }
                            lab.assigned = true
                        } else if (associationType === ASSOCIATION_TYPE.OPERATION.key && association[ASSOCIATION_TYPE.OPERATION.key].global) {
                            allLabs = associationParsed.laboratories.find(associationParsedLab => associationParsedLab.all)
                            allLabs.assigned = true
                            allLabs.userappOperationId = association.id
                        }
                    }
                })
            })
            const labsAssigned = associationParsed.laboratories.filter(lab => lab.assigned).length
            allLabs = associationParsed.laboratories.find(lab => lab.all)
            if (labsAssigned === laboratories.length - 1) {
                allLabs.assigned = true
            }
        }
    }
}
